export const nb = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Legg til tekst',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Legg til i handlevogn',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Juster bunnen',
  ALIGN_CENTER_KEY: 'justere senteret',
  ALIGN_KEY: 'rette inn',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'juster midten',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Juster toppen',
  ALL_TAB_TITLE_KEY: 'Alle',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Bakgrunn',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Ingen inspirasjon funnet under denne kategorien',
  BRING_TO_FRONT_KEY: 'Legg fremst',
  CANCEL_TEXT_KEY: ' Avbryt',
  CENTIMETERS_KEY: 'centimeter',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Velg fil',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Fjern alle',
  CLEAR_COLOR_KEY: 'Fjern farge',
  CLOSE_WINDOW_KEY: 'Lukk vinduet',
  CLEAR_ALL_OBJECTS: 'Fjern alle objekter',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Dette vil fjerne alle objekter fra bakgrunnen.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Farge',
  CONTINUE_KEY: 'Fortsett...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Design',
  DELETE_KEY: 'Slett',
  DOCUMENT_COLORS: 'Dokumentfarger',
  DONE: 'Done!',
  DONE_KEY: 'Ferdig',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Last ned',
  DOWNLOAD_APP_TITLE_KEY: 'Last ned appen her:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox-import',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime søk',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime bilder',
  DUPLICATE_KEY: 'Dupliser',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Rediger design',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Vi beklager, men det oppstod en feil. Prøv igjen senere.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Oops, det oppstod en feil ved åpning av den opplastede PDF-filen.',
  EMAIL_KEY: 'E-post',
  EMAIL_ADDRESS_KEY: 'E-postadresse:',
  EMAIL_CHECKBOX_MESSAGE:
    'Jeg vet at denne personen forstår at han/hun vil motta e-post fra HP på vegne av meg eller denne tjenesteleverandøren.',
  EXTRA_INFO_KEY: 'Ytterligere informasjon',
  EMAIL_NOTIFICATION:
    'En e-postmelding blir sendt snart. Behandlingen kan ta opptil 15 minutter.',
  EMAIL_DIALOG_MESSAGE:
    'Skriv inn e-postadressen til personen du vil dele utformingen med.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Eksisterende mappe',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Kontroller at alle valgte elementer er riktige før du fortsetter til kassen',
  FINAL_CHECK_TITLE_KEY: 'Siste sjekk',
  FINISH_KEY: 'Fullfør',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Vend',
  FOR_KEY: 'til',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Søkeord:',
  FOLDER_NAME: 'Mappenavn',
  FOLDER_NAME_KEY: 'Mappenavn:',
  FOLDER_ALREADY_EXIST_KEY: 'Dette mappenavnet finnes allerede',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Grupper alle',
  GROUP_SCALE: 'Gruppeskala',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Gi prosjektet et navn',
  HEIGHT_KEY: 'Høyde',
  HELP_KEY: 'Hjelp',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'BILDER',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importerer',
  INCHES_COLUMN_HEADER_KEY: 'Tommer',
  INCHES_KEY: ' tommer',
  INCHES_UNIT_STRING_KEY: 'tm.',
  INVALID_EMAIL_ADDRESS_KEY: 'Ugyldig e-postadresse',
  INVALID_INFO_KEY: 'Skriv inn detaljer.',
  INVALID_NAME_KEY: 'Ugyldig navn',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Beklager, men filen du valgte, er for stor. Maksimal filstørrelse er 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Oops, det er ikke et gyldig filformat. Vi kan håndtere bare pdf, jpg, png, svg og tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Språk',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Finn ut mer',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Ved å bruke dette nettstedet, godtar du å være bundet av disse',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Nettstedet er i overensstemmelse med',
  LEGAL_FOOTER_MESSAGE3_KEY: 'og',
  LENGTH_STRING_IN_INCHES_KEY: 'tm',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Hvis du vil visualisere innholdet du legger til, kan du laste ned LinkReader-appen.',
  LOADING_KEY: 'Laster...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Lås',
  LOGIN_KEY: 'Logg på',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Logg inn på Dreamstime ',
  LOGOUT_KEY: 'Logg av',
  MATERIAL_TITLE_KEY: 'MATERIALE',
  MATERIAL_STRING_KEY: 'Materiale',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Denne bakgrunnen kan ikke skaleres ned mer fordi du har nådd minimumshøyden eller -bredden som kreves for å dekke veggen.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Modell',
  MORE_INFO_TEXT_KEY: 'Mer informasjon',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Navn:',
  NEXT_BUTTON_TITLE_KEY: 'NESTE',
  NEW_FOLDER_KEY: 'Ny mappe',
  NO_SHADOW_KEY: 'Ingen skygge',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Bestill prøve',
  ORDER_SAMPLE: 'Bestill en prøve',
  ORDER_SAMPLE_INFOLABEL_1:
    'Velg den delen av bildet du vil bestille en prøve av',
  ORDER_SAMPLE_INFOLABEL_2:
    'Du får en e-post med et nærbilde av prosjektet i faktisk størrelse',
  ORDER_SAMPLE_INFOLABEL_3: 'Da kan du lettere vurdere kvalitet og oppløsning',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Bestill prøve nå',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Få en e-postmelding som inneholder en detaljert visning av prosjektet i faktisk størrelse slik at du kan evaluere kvaliteten/oppløsningen.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Passord',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Jeg eier opphavsretten til dette bildet og er enig i',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Piksel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'f.eks. viktige opplysninger du trenger å overbringe til trykkeriet',
  PLACEHOLDER_INCHES_STRING_KEY: 'tm',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Plassering',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Lagre prosjektet',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Prosjektet har endringer som må lagres før du fortsetter.',
  PRICE_COLUMN_HEADER_KEY: 'Pris',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Behandler...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Forhåndsvis',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Prosjektnavn',
  PROJECT_NAME: 'Prosjektnavn:',
  PROJECT_ALREADY_EXIST_KEY: 'Dette prosjektnavnet finnes fra før',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Dette prosjektnavnet finnes fra før',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Dette mappenavnet finnes allerede',
  PIXELATION_WARNING_KEY: 'Pikseleringsvarsel',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'På grunn av oppløsningen til det opplastede bildet ditt, kan huden din være forvrengt eller forvrengt. For å sikre at det ikke blir uskarpt, må du laste opp et bilde av god kvalitet og unngå å strekke bildet. Hvis du er fornøyd med forhåndsvisningen og vil fortsette, fortsett å sende inn.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'PÅKREVD',
  RECOLOR_KEY: 'Endre farge',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Endre farge',
  REQUEST_SAMPLE_KEY: 'Be om en prøve',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Tilbudsforespørsel',
  RIGHT_LOGO_TEXT_KEY: 'av',
  ROTATE_KEY: 'Roter',
  ROTATE_LEFT_KEY: 'Roter 90° mot venstre',
  ROTATE_RIGHT_KEY: 'Roter 90° mot høyre',
  ROTATION_KEY: 'Rotering',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Rader og kolonner',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Lagre',
  SAVING_KEY: 'Lagrer...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Lagre prosjektet',
  SAVE_PROJECT_NAME_KEY: 'Lagre prosjektet først',
  SAVEDIALOG_MESSAGE:
    'Logg på for å lagre prosjektet. Hvis du ikke har en konto, hjelper vi deg med å opprette en. Fremdriften din går ikke tapt.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Skaler',
  SCALE_ALL_KEY: 'Skaler alle',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Søk',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Søk',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Send meg installasjonsveiledningen',
  SEND_TO_BACK_KEY: 'Legg bakerst',
  SEND_KEY: 'Send',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Angi størrelse',
  SETTINGS_KEY: 'Innstillinger',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Del',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'kv. ft.',
  SQM_UNIT_STRING_KEY: 'kv. m.',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Sende inn',
  SHARE_LINK_LABEL: 'Velg hvilken type lenke du vil dele',
  SHARE_EDIT_LINK: 'Rediger lenke',
  SHARE_VIEW_LINK: 'Vis lenke',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* Målvisningsavstand kan endres fra innstillingene.',
  TERMS1_KEY: 'vilkår',
  TERMS2_KEY: 'HP Personvernerklæring',
  TERMS3_KEY: 'HP Merknad om rettigheter til personlige data',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Vilkår for bruk.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Side ved side',
  TOTAL_KEY: 'TOTALT',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Takk',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Lås opp',
  UNGROUP_KEY: 'Oppløs gruppe',
  UPDATE_TEXT_KEY: 'Oppdater',
  UPLOAD_KEY: 'Bildeopplasting',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Brukernavn',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Angre Side ved side',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Gyldighet',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'MVA',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Vis i Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Vis designdetaljer',
  VIEW_DESIGNER_PROFILE_KEY: 'Vis Designer-profil',
  VIEW_PRICE_KEY: 'Vis pris',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Veggplakat',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Advarsel',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Bredde',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Ditt navn',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Ditt prosjekt:',
  PROJECT_NAME_ERROR_TEXT: 'Skriv inn et navn for prosjektet.',
  PROJECT_FOLDER_ERROR_TEXT: 'Skriv inn et navn for prosjektmappen.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minste visningsavstand',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Ingen Innhold funnet',
  NO_ELEMENT_ERROR_MESSAGE: 'Fant ingen elementer.',
  NO_MORE_IMAGES_FOUND_KEY: 'Ingen flere bilder funnet',
  NO_PATTERN_ERROR_MESSAGE: 'Finner ingen mønstre.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Melding:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Du har skalert til et punkt der det utskrevne bildet kan se pikselert ut når det vises ved {0} {1} * (gjeldende utskriftsoppløsning er {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Anbefalt visningsavstand vil være {0} {1}. Hvis dette ikke passer, må du redusere skalaen på bildet eller størrelsen på veggrafikken.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Anbefalt minimumsstørrelse på bildet er {0} x {1} piksler.',
  UPLOAD_STATUS: '{0}% av {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Minimumsmålene er {0} (b) ganger {1} (h).',
  MINIMUM_HEIGHT_KEY: 'Minimumshøyden er {0}.',
  MINIMUM_WIDTH_KEY: 'Minimumsbredden er {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'Maksimal bredde er {0}',
  MAXIMUM_HEIGHT_KEY: 'Maksimal høyde er {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Sett inn numeriske mål som er større enn null.',
  PROCESSING_FAILED: 'Behandling mislyktes. Prøv igjen etter en stund.',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Beklager, det er ikke støtte for PDF-filer med flere sider.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Beklager, krypterte PDF-filer støttes ikke.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importerer fil {0} av {1}',
  RECOLORING_KEY: 'Endrer farger...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'Denne innholdskilden er passordbeskyttet',
  AUTHENTICATE_FAILED_MESSAGE: 'Godkjenning mislyktes!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Det oppstod et problem med import av enkelte filer',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Denne inspirasjonsmalen kommer med en standardstørrelse på {0} X {1} {2}. Sidestørrelsen blir automatisk endret for å passe til denne malen.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Velg din bærbare PC',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Fornavn',
  LAST_NAME_KEY: 'Etternavn',
  PHONE_NUMBER_KEY: 'Telefonnr.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Ugyldig telefonnummer',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Jeg aksepterer vilkår og betingelser',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Jeg aksepterer at min personlige informasjon vil bli delt med HP slik at jeg kan bli kontaktet om fremtidige HP-kampanjer.*',
  SERVICE_PROVIDER_CONDITION:
    'Jeg godtar at dataene jeg oppgir kan deles med tjenesteleverandører for trykkings- og leveringsformål.*',
  ORDER_DESIGN: 'Bestill design',
  SUBMIT_YOUR_DESIGN: 'Send inn designet ditt',
  SUBMISSION_DESIGN_ORDER: 'Innsending av designbestilling',
  ENTER_REQUIRED_FIELDS_KEY: 'Skriv inn obligatoriske felt',
  ADDRESS_KEY: 'Addresse',
  INVALID_ADDRESS_KEY: 'Ugyldig adresse',
  CITY_KEY: 'By',
  INVALID_CITY_KEY: 'Ugyldig by',
  COUNTRY_KEY: 'Land',
  STATE_KEY: 'Stat',
  ZIP_KEY: 'Post',
  INVALID_ZIP_KEY: 'Ugyldig postnummer',
  ORDER_NUMBER: 'Bestillingsnummer',
  YOUR_DETAILS_KEY: 'Dine detaljer',
  APPLY_DESIGN_COMPETITION: 'Søk på designkonkurransen',
  NOTICE_KEY: 'Legge merke til:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'For å ha en PC-hud perfekt tilpasset din, må du velge den nøyaktige modellen som tilsvarer kjøpet, slik det fremgår av fakturaen.',
  RESTART_PROJECT_ALERT_TITLE: 'Starte et prosjekt på nytt?',
  DISCARD_ALERT_MESSAGE: 'Nåværende prosjekt vil bli forkastet',
  RESTART: 'Start på nytt',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Advarsel om sidestørrelse!',
  MODIFY_SIZE_WARNING:
    'Hvis du ønsker å endre størrelsen på dette designet, kan du gjøre det under fanen Innstillinger. Designelementer kan kreve redigering for å tilpasse seg ønsket dimensjoner.',
  RANDOMIZE_KEY: 'Tilfeldig',
  MATERIAL_CHOICE_APPLIED: 'Materiellvalg brukt.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'sertifikat på',
  AUTHENTICITY_STRING: 'ekthet',
  PLEASE_WAIT: 'Vent litt',
  PROTECTING_YOUR_DATA: 'beskytter dataene dine...',
  SEARCH_YOUR_LAPTOP_KEY: 'Søk på den bærbare datamaskinen din', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Oops! Vi kunne ikke finne noen bærbare datamaskiner for søket ditt.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Serienummer',
  LOCKED_PROJECT: 'Låst prosjekt',
  LOCKED_MESSAGE:
    'Dette prosjektet er bestilt og kan ikke endres. Du kan bare se dette prosjektet.',
  EXPIRED_PROJECT: 'Utløpt prosjekt',
  EXPIRED_MESSAGE: 'Dette prosjektet er utløpt.',
  DELETED_PROJECT: 'Slettet prosjekt',
  DELETED_MESSAGE: 'Dette prosjektet har blitt slettet.',
  CHOOSE_GROUP_TYPE: 'Velg {0} type',
  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Skriv inn tall som er større enn null.',
  SIZE_KEY: 'Størrelse',
  DISTANCE_FROM_KEY: 'Avstand fra',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Venstre',
  RIGHT_KEY: 'Høyre',
  DELETE_WALL_KEY: 'Delete a wall',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Maksimal veggstørrelse er {0} sq.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'Høyden på lerretet er større enn vegghøyden.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'Bredden på lerretet er større enn veggbredden.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Maksimalt antall kolonner for gjeldende bredde er {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Maksimalt antall rader for gjeldende høyde er {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Veggbredden er mindre enn lerretsbredden.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Veggen må ha en minimumsbredde på {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Veggen må ha en minimumshøyde på {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Vegghøyden er mindre enn lerretshøyden.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maksimal vegghøyde er {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Rader',
  COLUMNS_KEY: 'Kolonner',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Rediger',
  TOP_KEY: 'Topp',
  BOTTOM_KEY: 'Bunn'
};
